<div class="race-timer race-div">
    @if (displayCountdown && isCountdown()) {
        <div class="countdown" data-crlat="raceCountdown">
            <span class="label lads-text" [ngClass]="{ textCapitalize: brand === 'ladbrokes' }" [i18n]="'racing.startsIn'" data-crlat="label"></span>
            <span class="value" data-crlat="value">{{ raceCountdown }}</span>
        </div>
    }
    @if (displayTime && isTime()) {
        <div class="time">
            <span class="label" [i18n]="'racing.startsAt'"></span>
            <span class="value">{{ raceStartTime }}</span>
        </div>
    }
</div>
